import { FC, ReactElement } from 'react'
import { useRouter } from 'next/router'

import Button from 'components/parts/button/button'

import { useAuth } from 'store/auth/useAuth'
import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'

import styles from './ai-button.module.scss'

interface IAiButton {
  children: string | ReactElement
}

const AiButton: FC<IAiButton> = ({ children }) => {
  const { isAuthorized } = useAuth()
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const btnHandler = () => {
    if (isAuthorized) {
      router.push('/ai-bolit')
    } else {
      router.push(`${path}#${popupName.registration}`)
    }
  }
  return (
    <Button onClick={btnHandler} modificator={styles.btn}>
      {children}
    </Button>
  )
}

export default AiButton
